import { useTranslation } from "react-i18next";

interface CloneAsProps {
    id: string;
    direction: string;
    cloneAs: CallableFunction;
}

export default function CloneAs(props: CloneAsProps) {
    const { t } = useTranslation();
    
    const handleCopyCloneAs = () => {
        props.cloneAs(props.id, props.direction);
    }

    return (
        <a className="btn btn-warning clone-as" onClick={ handleCopyCloneAs }>
            { props.direction == 'pre-to-pos' && t("Clone as Pos-task") }
            { props.direction == 'pos-to-pre' && t("Clone as Pre-task") }
        </a>
    );
}